var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"Période","items":_vm.periods,"light":_vm.light,"dark":_vm.dark},model:{value:(_vm.period),callback:function ($$v) {_vm.period=$$v},expression:"period"}})}
var staticRenderFns = []

export { render, staticRenderFns }